// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiInputTags = styled('div')(
  () => css`
    .tag-input {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      border: 1px solid #eeeeee;
      outline: 1px solid #eeeeee;
      border-radius: 6px;
      background-color: white;
      color: #222222;
      min-height: 112px;
      cursor: text;

      &:hover {
        box-shadow: 0px 0px 0px 3px rgba(117, 196, 200, 0.3);
        border: 1px solid #75c4c8;
      }

      &.error {
        border-color: #d32f2f;
        overflow: hidden;

        &:hover {
          box-shadow: 0px 0px 0px 3px rgba(211, 47, 47, 0.3);
        }
      }

      textarea {
        flex: 1;
        border: none;
        font-size: 0.875rem;
        font-weight: 600;
        color: #333;
        caret-color: #75c4c8;
        padding-right: 0.5em;

        &:focus {
          outline: transparent;
        }

        resize: none;

        &::placeholder {
          color: #aaa;
          font-size: 12px;
          font-weight: 700;
          line-height: 24px;
        }
      }

      .tags {
        display: flex;
        flex-wrap: wrap;
        list-style-type: none;
        padding: 0;
        margin: 0;
        cursor: default;

        .tag {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          padding: 0.8em 0.9em 0.7em 0.5em;
          font-size: 0.75rem;
          border-radius: 6px;
          margin: 0.2em 0.3em;
          background: #0052cc;
          border: 1px solid #e4e9ec;
          word-break: break-word;

          &:first-of-type {
            margin-right: 0.2em;
          }

          .tag-title {
            margin-left: 5px;
          }

          .tag-close-icon {
            transition: all 0.2s ease;
          }
        }
      }
    }
  `
);
